module.exports = __webpack_public_path__ + "img/retirees_63021.2f5cf2d0.jpg";